import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class ReelFrameView extends PIXI.Container implements StageLayer {

    private freespinFrame:PIXI.Container = new PIXI.Container();

    constructor() {
        super();
        this.name = "ReelFrameView";
        this.init();
    }

    init() {

        /*
            TODO: Global layering of fs-elements, from bottom
            - fs_reel
            - coin symbols
            - reel backlight
            - glow vertical/horizontal
            - reel overlay
         */

        this.addChild(this.freespinFrame);

        this.onOrientationChanged();
    }

    public switchReelFrame(modeId:string) {

        if(modeId === DevilsCrossRoadGameMode.NORMAL) {
            this.freespinFrame.visible = true;
            DevilsCrossRoad.reels.reelView.show(true);
        } else if(modeId === DevilsCrossRoadGameMode.FREESPIN || modeId === DevilsCrossRoadGameMode.SUPER_FREESPIN) {
            this.freespinFrame.visible = true;
        }

    }

    public onOrientationChanged() {
        if(NolimitApplication.isLandscape) {

        }
    else {

        }
    }

}